/* eslint-disable */

import React from 'react';

const Social = () => {
    return (
        <div className='home__social'>
            <a href='https://www.linkedin.com/in/tonnytei/' className='home__social-icon' target="_blank">
            <i className="uil uil-linkedin-alt"></i>
            </a>
            <a href='https://twitter.com/tonnytei' className='home__social-icon' target="_blank">
            <i className="uil uil-twitter-alt"></i>
            </a>
            <a href='https://github.com/tonnytech' className='home__social-icon' target="_blank">
            <i className="uil uil-github-alt"></i>
            </a>
           
        </div>
    );
};

export default Social;